<template>
    <div>
        <span v-for="linkedObject in linkedObjects" class="badge text-bg-light me-1 mt-1">{{linkedObject}}</span>
    </div>
</template>

<script>
    export default {
        name: 'LinkedObjectRenderer',
        props: ['field', 'document'],
        computed: {
            fieldValue() {
                return this.document[this.field.index]
            }
        },
        data () {
            return {
                model: webase.model,
                linkedObjects: []
            }
        },
        mounted() {
            webase.eventDispatcher.on('onLinkedObjectSelected', this.onDataLinked)
            this.refresh()
        },
        beforeUnmount() {
            webase.eventDispatcher.off('onLinkedObjectSelected', this.onDataLinked)
        },
        methods: {
            onDataLinked(document) {

                if(this.document['id'] === document['id']) {
                    this.refresh()
                }

            },
            refresh() {
                this.linkedObjects = []

                let documentIds = Object.keys(this.fieldValue)

                for(let i = 0; i < documentIds.length; i++) {
                    let documentId = documentIds[i]
                    this.linkedObjects.push(this.fieldValue[documentId])
                }

                console.log('LinkedObjectRenderer Refreshed')
                console.log(this.linkedObjects)
            }
        }
    }
</script>

<style>

</style>
